(ns io.daskul.webapp.aggregates.db
  "Aggregate DB structure conventions.

   Uses normalized state structure:
   - [:aggregates agg-key id] - Individual records by ID
   - [:ui agg-key ...] - UI state (loading, errors, current-id, list-ids)
   - [:schemas agg-key operation] - Form schemas
   - [:lookups agg-key field-key] - Lookup field options
   - [:embedded agg-key parent-id rel-name] - Embedded relationships
   - [:child-aggregates parent-agg-key parent-id child-agg-key] - Child aggregates
   - [:counts agg-key group-by-field] - Grouped counts for segmented filters")

;; ============================================================================
;; Aggregate Entities (normalized by ID)
;; ============================================================================

(defn entity-path
  "Path to a specific entity by ID."
  [agg-key id]
  [:aggregates agg-key id])

(defn entities-path
  "Path to all entities map for an aggregate."
  [agg-key]
  [:aggregates agg-key])

;; ============================================================================
;; UI State
;; ============================================================================

(defn ui-path
  "Path to UI state for an aggregate."
  [agg-key & path-parts]
  (into [:ui agg-key] path-parts))

(defn list-ids-path [agg-key]
  (ui-path agg-key :list-ids))

(defn current-id-path [agg-key]
  (ui-path agg-key :current-id))

(defn loading-path [agg-key]
  (ui-path agg-key :loading?))

(defn creating-path [agg-key]
  (ui-path agg-key :creating?))

(defn updating-path [agg-key]
  (ui-path agg-key :updating?))

(defn deleting-path [agg-key]
  (ui-path agg-key :deleting?))

(defn error-path [agg-key]
  (ui-path agg-key :error))

(defn schema-loading-path [agg-key]
  (ui-path agg-key :schema-loading?))

(defn transitioning-path [agg-key]
  (ui-path agg-key :transitioning?))

(defn transition-event-path [agg-key]
  (ui-path agg-key :transition-event))

(defn transition-errors-path [agg-key]
  (ui-path agg-key :transition-errors))

;; ============================================================================
;; Schemas
;; ============================================================================

(defn schema-path
  "Path to schema for an operation."
  [agg-key operation]
  [:schemas agg-key operation])

;; ============================================================================
;; Lookups
;; ============================================================================

(defn lookup-path
  "Path to lookup data for a field."
  [agg-key field-key & path-parts]
  (into [:lookups agg-key field-key] path-parts))

;; ============================================================================
;; Embedded Relationships
;; ============================================================================

(defn embedded-path
  "Path to embedded relationship data."
  [agg-key parent-id rel-name & path-parts]
  (into [:embedded agg-key parent-id rel-name] path-parts))

;; ============================================================================
;; Child Aggregates
;; ============================================================================

(defn child-path
  "Path to child aggregate data."
  [parent-agg-key parent-id child-agg-key & path-parts]
  (into [:child-aggregates parent-agg-key parent-id child-agg-key] path-parts))

;; ============================================================================
;; Counts (segmented filter badges)
;; ============================================================================

(defn pagination-path
  "Path to pagination metadata for an aggregate."
  [agg-key]
  (ui-path agg-key :pagination))

(defn counts-path
  "Path to grouped counts for an aggregate field."
  [agg-key group-by-field]
  [:ui agg-key :counts group-by-field])
